import React, { useCallback } from 'react';
import Fullscreen from '@uber/base-icons/fullscreen';
import ZoomIn from '@uber/base-icons/zoom-in';
import ZoomOut from '@uber/base-icons/zoom-out';
import ToolbarButton from '../../../../common/toolbar-button';
import useAnalyticsFoStageToolBar from '../../../labelling/components/stage-toolbar/analytics/useAnalyticsForStageToolBar';
import { useFitToScreen } from '../../hooks/use-fit-to-screen';
import { useStageSettings } from '../../hooks/use-stage-settings';
import { CONTROL_TYPES } from './constants';
import { ToolbarPopover } from './toolbar-popover';
const ZOOM_ACTION = ({
  ZOOM_IN: 'ZOOM_IN',
  ZOOM_OUT: 'ZOOM_OUT'
} as const);
const ZOOM_IN_FACTOR = -0.1;
const ZOOM_OUT_FACTOR = 0.1;
export const SELECTOR_IDS = ({
  ZOOM: 'zoom-button',
  ZOOM_IN: 'zoom-in-button',
  ZOOM_OUT: 'zoom-out-button',
  FIT_TO_SCREEN: 'fit-to-screen-button'
} as const);
const zoomButtonAttributes = {
  'data-testid': 'zoom',
  'data-selector-id': SELECTOR_IDS.ZOOM
};
const zoomInButtonAttributes = {
  'data-testid': 'zoom-in',
  'data-selector-id': SELECTOR_IDS.ZOOM_IN
};
const zoomOutButtonAttributes = {
  'data-testid': 'zoom-out',
  'data-selector-id': SELECTOR_IDS.ZOOM_OUT
};
const fitToScreenButtonAttributes = {
  'data-testid': 'fit-to-screen',
  'data-selector-id': SELECTOR_IDS.FIT_TO_SCREEN
};
function ZoomControl() {
  const [stageSettings, setStageSettings] = useStageSettings();
  const [fitToScreen] = useFitToScreen();
  const {
    sendEventChangeControls
  } = useAnalyticsFoStageToolBar();
  const onZoomClick = useCallback((action: (typeof ZOOM_ACTION)[keyof typeof ZOOM_ACTION]) => {
    const {
      scale: existingScale
    } = stageSettings;
    const sign = action === ZOOM_ACTION.ZOOM_IN ? ZOOM_IN_FACTOR : ZOOM_OUT_FACTOR;
    const scale = 1 - sign;
    setStageSettings({
      ...stageSettings,
      scale: existingScale * scale
    });
    sendEventChangeControls({
      action: CONTROL_TYPES.ZOOM,
      value: scale.toString()
    });
  }, [stageSettings, setStageSettings, sendEventChangeControls]);
  return <>
      <ToolbarPopover trigger={<ToolbarButton title="Zoom" attributes={zoomButtonAttributes}>
            <ZoomIn title="Zoom" />
          </ToolbarButton>}>
        <ToolbarButton title="Zoom In" attributes={zoomInButtonAttributes} onClick={() => onZoomClick(ZOOM_ACTION.ZOOM_IN)}>
          <ZoomIn title="Zoom In" />
        </ToolbarButton>
        <ToolbarButton title="Zoom Out" attributes={zoomOutButtonAttributes} onClick={() => onZoomClick(ZOOM_ACTION.ZOOM_OUT)}>
          <ZoomOut title="Zoom Out" />
        </ToolbarButton>
      </ToolbarPopover>

      <ToolbarButton title="Fit to Screen" onClick={() => {
      fitToScreen();
      sendEventChangeControls({
        action: CONTROL_TYPES.FIT_TO_SCREEN
      });
    }} attributes={fitToScreenButtonAttributes}>
        <Fullscreen title="Fit to Screen" />
      </ToolbarButton>
    </>;
}
export default ZoomControl;